import React from "react";
import Input from "components/elements/Input/Input";
import Select from "components/elements/Input/Select";

/**
 * Component for collecting address information during checkout
 */
const AddressForm = ({ formData, formErrors, onChange }) => {
	return (
		<>
			<h3 className="fs-5 mb-3">Rechnungsadresse</h3>
			<div className="row g-3">
				<div className="col-md-8">
					<Select
						id="country"
						name="country"
						label="Land"
						value={formData.country}
						onChange={onChange}
						options={[
							{ value: "DE", label: "Deutschland" },
							{ value: "AT", label: "Österreich" },
							{ value: "CH", label: "Schweiz" }
						]}
						required
						aria-required="true"
						aria-label="Land auswählen"
						data-field="country"
					/>
				</div>
				<div className="col-md-8">
					<Input
						type="text"
						id="street"
						name="street"
						label="Straße und Hausnummer"
						value={formData.street}
						onChange={onChange}
						error={formErrors.street}
						required
						aria-required="true"
						aria-label="Straße und Hausnummer eingeben"
						data-field="street"
					/>
				</div>
				<div className="col-md-8">
					<Input
						type="text"
						id="addressSuffix"
						name="addressSuffix"
						label="Adresszusatz (optional)"
						value={formData.addressSuffix}
						onChange={onChange}
						placeholder="z.B. Etage, Wohnung"
						aria-label="Adresszusatz eingeben"
						data-field="addressSuffix"
					/>
				</div>
				<div className="col-md-8">
					<div className="row mb-4">
						<div className="col-md-4">
							<Input
								type="text"
								id="zipCode"
								name="zipCode"
								label="Postleitzahl"
								value={formData.zipCode}
								onChange={onChange}
								error={formErrors.zipCode}
								required
								aria-required="true"
								aria-label="Postleitzahl eingeben"
								data-field="zipCode"
							/>
						</div>
						<div className="col-md-8">
							<Input
								type="text"
								id="city"
								name="city"
								label="Ort"
								value={formData.city}
								onChange={onChange}
								error={formErrors.city}
								required
								aria-required="true"
								aria-label="Ort eingeben"
								data-field="city"
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default AddressForm;
